import React from 'react';
import { COLORS } from '../../../../utilities/theme/colors';
import './ProductCard.scss';

export const ProductCard = props => {
  const { item, clickHandler, isWhiteBackground, IconUrl } = props;

  return (
    <div
      role='button'
      tabIndex='0'
      className='product-container'
      onClick={() => {
        clickHandler(item);
      }}
      onKeyPress={() => {}}
      id={
        item.name && item.name == 'Multi Canvas'
          ? 'multi-canvas'
          : 'product-container-id'
      }
    >
      <div
        className='product-image'
        style={{
          backgroundColor: isWhiteBackground() ? COLORS.bgWhite : null
        }}
      >
        <img
          src={item.productIconUrl ? item.productIconUrl : IconUrl}
          alt='img'
        />
      </div>
      <div className='product-Name'>
        {item.modelNumber ? item.modelNumber : item.name}
        {item.invoiceCode ? ` (${item.invoiceCode})` : null}
      </div>
    </div>
  );
};
